interface SeoMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schema?: object;
}

export function SeoMeta({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schema }: SeoMetaProps) {
  document.title = title;

  const setMeta = (name: string, content: string, isProperty = false) => {
    const attr = isProperty ? 'property' : 'name';
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('description', description);
  setMeta('keywords', keywords);

  const linkEl = document.querySelector('link[rel="canonical"]');
  if (linkEl) {
    linkEl.setAttribute('href', canonicalUrl);
  } else {
    const newLink = document.createElement('link');
    newLink.setAttribute('rel', 'canonical');
    newLink.setAttribute('href', canonicalUrl);
    document.head.appendChild(newLink);
  }

  setMeta('og:title', title, true);
  setMeta('og:description', description, true);
  setMeta('og:type', ogType, true);
  setMeta('og:url', canonicalUrl, true);
  if (ogImage) {
    setMeta('og:image', ogImage, true);
  }

  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', title);
  setMeta('twitter:description', description);

  if (schema) {
    const existingScript = document.querySelector('script[type="application/ld+json"][data-schema="page"]');
    if (existingScript) {
      existingScript.remove();
    }
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'page');
    script.textContent = JSON.stringify(schema, null, 2);
    document.head.appendChild(script);
  }

  return null;
}

export function SchemaOrg({ schema }: { schema: object }) {
  const schemaStr = JSON.stringify(schema, null, 2);
  const schemaId = `schema-${Math.random().toString(36).slice(2, 9)}`;

  return (
    <script
      type="application/ld+json"
      data-schema-id={schemaId}
      dangerouslySetInnerHTML={{ __html: schemaStr }}
    />
  );
}